(function($) {
  const moderate = () => { 
    const $users = $('.moderate-user')
    const $affiliates = $('.moderate-affiliate')

    $users.each(function() {
      const $approveBtn = $(this).find('.btn-approve')
      const $rejectBtn = $(this).find('.btn-reject')
      const userId = $(this).data('user-id')

      $approveBtn.on('click', function() {
        moderateItem('user', userId, 'approve', $(this))
      })
      $rejectBtn.on('click', function() {
        moderateItem('user', userId, 'reject', $(this))
      })
    })

    $affiliates.each(function() {
      const $approveBtn = $(this).find('.btn-approve')
      const $rejectBtn = $(this).find('.btn-reject')
      const affiliateId = $(this).data('affiliate-id')

      $approveBtn.on('click', function() {
        moderateItem('affiliate', affiliateId, 'approve', $(this))
      })
      $rejectBtn.on('click', function() {
        moderateItem('affiliate', affiliateId, 'reject', $(this))
      })
    })
  }

  function moderateItem(type, id, action, $button) {
    fetch('/wp-json/um/v1/moderate/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': wpApiSettings.nonce 
      },
      body: JSON.stringify({
        type: type,
        id: id,
        action: action
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      (action === 'approve') ? $button.parent().find('.btn-reject').remove() : $button.parent().find('.btn-approve').remove()
      $button.addClass('btn-message')
      $button.css('width', 'auto')
      $button.find('span').text(data.message)
      setTimeout(() => {
        $button.closest('.moderate-user, .moderate-affiliate').fadeOut(function() {$(this).remove()})
      }, 2500);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  $(function() {
    moderate()
  })
})(jQuery);
